/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import './index.css'
import { Container, Row, Col, Table, Form } from 'react-bootstrap'
import { WtTheme } from '../../controller/theme'
import { Client } from '../home/ui'
import { Link, useHistory } from 'react-router-dom'
import { Testimonial } from './ui'
import { WtUrl } from '../../constants/urls'
import { WtColor } from '../../constants/colours'
import { WtString } from '../../constants/strings'
import { isMobile } from 'react-device-detect'
import { Dialog, DialogContent, Slide } from '@mui/material'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { ShowSnackbar } from '../../controller/BaseTool'
import { LinkedIn } from '@mui/icons-material'


// Chatbot Page UI
export const Chatbots = () => {
    return (
        <div className="">
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <div className="mt-5">
                            <h1>
                                Start your digital transformation journey with <b>AI chatbots</b> to deliver automated and personalised experience
                            </h1>
                            <p className="text-muted mt-5">
                                We at Whatstool help lead your business’s customer service<br />journey through all key touchpoints. Engage your customers with<br />24x7 Chatbot support and grow your business widely.
                            </p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                        <div>
                            <p className="text-center">
                                <img src={WtTheme.ImageBaseUrl + "/wtb_05.png"} style={{ width: '70%' }} className="img-fluid" alt={WtTheme.SiteName} />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="clients" fluid><Client /></Container>
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <div className="mt-5">
                            <h3 className="theme">Generate leads 24x7 and Grow<br />your business with Chatbots</h3>
                            <p className="text-muted mt-5">
                                Be available to your customers around the clock, never miss out on<br />a lead again! Our dashboard ensures customer conversations are<br />accounted for through Assignee, @Mentions, and Tagging.
                            </p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                        <div>
                            <p className="text-center p-5">
                                <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_02.png"} className="img-fluid" alt={WtTheme.SiteName} />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="clients pe-3 ps-3" fluid>
                <Container className="mt-5 mb-5 pb-5">
                    <Row>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                            <div>
                                <p className="text-center p-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_03.png"} className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                            </div>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <div className="mt-5">
                                <h3 className="theme">Build your Bot within a matter of<br />minutes. No codes, just<br />conversational flow.</h3>
                                <p className="text-muted mt-5">
                                    Setup your Chatbot to interact with users just like any agent would.<br /> Create, test, and run your no-code Chatbot. Set a standard with<br />the quality of customer support, engagement, and interaction.
                                </p>
                                <p className="mt-5"><Link to={WtUrl.signupUrl} className="btn btn-md ps-5 pe-5 pt-2 pb-2 text-white fw-bold" style={{ background: "#128C7E" }}>Start Building</Link></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <h5 className="fw-bold mt-5 mb-5 text-center">BENEFITS OF WHATSAPP CHATBOT</h5>
                <Container className="pe-5 ps-5">
                    <Row>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_01.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Effectively and instantly<br />interact with clients</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_02.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Expand the company’s<br />availability and reach<br />&nbsp;</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_03.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Support customers by<br />responding to queries in<br />real-time</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_04.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Send contexual<br />responses automatically</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_05.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Personalize customer’s<br />experience</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_06.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Free up personnel to<br />solve more complex requests</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_07.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Make customer communications secure<br />by end-to-end encryption</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_08.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Shorten the sales<br />cycle<br />&nbsp;</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/wtx_chatbot_benifits_09.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Achieve better brand<br />recognition<br />&nbsp;</h6>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
// End of Chatbot Page UI

// MultiAgent Page UI
export const MultiAgent = () => {
    return (
        <div className="">
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <div className="mt-5">
                            <h1>
                                Multi-Agent Shared Workspace For Teams To Collaborate
                            </h1>
                            <p className="text-muted mt-5">
                                Have multiple attendants in a single number. A handy tool for sales and customer support
                            </p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                        <div>
                            <p className="text-center">
                                <img src={WtTheme.ImageBaseUrl + "/wtb_03.png"} className="img-fluid shadow-lg rounded-3" alt={WtTheme.SiteName} />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="clients" fluid><Client /></Container>
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <div className="mt-5">
                            <h3 className="theme">Get close to your customers at WhatsApp</h3>
                            <p className="text-muted mt-5">
                                Customers want only one thing: quick and very simple contact with you. Effectively serve your customers with online chat: Unlimited messaging and multimedia, chat history and unlimited staff.
                            </p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                        <div>
                            <p className="text-center p-5">
                                <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_001.png"} className="img-fluid" alt={WtTheme.SiteName} />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="clients pe-3 ps-3" fluid>
                <Container className="mt-5 mb-5 pb-5">
                    <Row>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                            <div>
                                <p className="pt-5 pb-5 pe-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_002.png"} className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                            </div>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <div className="mt-5">
                                <h3 className="theme">Optimize your company's WhatsApp service</h3>
                                <p className="text-muted mt-5">
                                    Keep several conversations under control: open a separate tab for each conversation. Take total control of your customer interactions - share a single WhatsApp account across multiple devices at the same time
                                </p>
                                <p className="mt-5"><Link to={WtUrl.signupUrl} className="btn btn-md ps-5 pe-5 pt-2 pb-2 text-white fw-bold" style={{ background: "#128C7E" }}>Get Started</Link></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <h5 className="fw-bold mt-5 mb-5 text-center">BENEFITS OF MULTIPLE CHAT SUPPORT</h5>
                <Container className="pe-5 ps-5">
                    <Row>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_001.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">More<br />Conversation</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_002.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Faster<br />Response</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_003.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Cost<br />Effectiveness</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_004.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Competitive<br />Advantage</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_005.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Greater Customer<br />Retention</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_006.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Increased<br />Sales</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WT_MultiAgent_Benefits_007.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Convenient for<br />Customers</h6>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
// End of MultiAgent Page UI

// BroadcastMessage Page UI
export const BroadcastMsg = () => {
    return (
        <div className="">
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <Row style={{ marginTop: "100px" }}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="mt-5">
                            <h1>
                                Broadcast Promotional Messages (Officially)
                            </h1>
                            <p className="text-muted mt-5">
                                Well, WhatsApp recently allowed Businesses to Broadcast and Automate Promotional Messages via Whatsapp Business API<br />
                                You can Now Send Exciting Offers, Discount Coupon Code and Festival Wishes without getting your Number blocked!
                            </p>
                        </div>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div>
                            <p className="float-end">
                                <img src={WtTheme.ImageBaseUrl + "/wtb_broadcast_001.png"} className="img-fluid" width="400px" alt={WtTheme.SiteName} />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="clients" fluid><Client /></Container>
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <div className="mt-5">
                            <h3 className="theme">Broadcast Messages in a Few Clicks</h3>
                            <p className="text-muted mt-5">
                                Import contacts with labels and additional fields to create segments, schedule broadcasting lists and view real-time analytics all with a few clicks.
                            </p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                        <div>
                            <p className="text-center p-5">
                                <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_002.png"} className="img-fluid" width="100%" alt={WtTheme.SiteName} />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="clients pe-3 ps-3" fluid>
                <Container className="mt-5 mb-5 pb-5">
                    <Row>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12}>
                            <div>
                                <p className="pt-5 pb-5 pe-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_003.png"} className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                            </div>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                            <div className="mt-5 pt-5">
                                <h3 className="theme">Set up segmented campaigns based on custom fields.</h3>
                                <p className="text-muted mt-5">
                                    Leverage the power of WhatsApp Marketing by starting a WhatsApp Broadcast for up to 100k recipients in a single click.
                                </p>
                                <p className="mt-5 pt-5"><Link to={WtUrl.signupUrl} className="btn btn-md ps-5 pe-5 pt-2 pb-2 text-white fw-bold" style={{ background: "#128C7E" }}>Get Started</Link></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container className="mt-5 mb-5 pe-3 ps-3">
                <h5 className="fw-bold mt-5 mb-5 text-center">BENEFITS OF BROADCAST MESSAGE</h5>
                <Container className="pe-5 ps-5">
                    <Row>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_Benefits_001.png"} width="230px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Wider Target<br />Reach</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_Benefits_002.png"} width="230px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Better Connect<br />with Customer</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_Benefits_003.png"} width="230px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Cost<br />Effectiveness</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_Benefits_004.png"} width="230px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Up-Sell and<br />Cross-sell products</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_Benefits_005.png"} width="230px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3"><br />Personilsed<br />Offers</h6>
                            </div>
                        </Col>
                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} className="p-3">
                            <div className="benefits_box">
                                <p className="text-center pt-5 ps-3 pe-3 pb-5">
                                    <img src={WtTheme.ImageBaseUrl + "/WTX_Broadcast_Benefits_006.png"} width="240px" className="img-fluid" alt={WtTheme.SiteName} />
                                </p>
                                <h6 className="text-center mt-3 mb-5 fw-bold ps-3 pe-3">Schedule New<br />Compaigns</h6>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </Container>
        </div>
    )
}
// End of BroadcastMessage Page UI

// Quick Guide Page UI
export const QuickGuide = () => {
    const FeaturesData = [
        { "t": "Free Whatsapp Business API", "d": "Get Whatsapp Business API Approval within 2 days (Free with any plan)", "img": WtTheme.ImageBaseUrl + "/WBApi.svg" },
        { "t": "Multi Agent Live Chat", "d": "Enable Multiple Human-Agent Live Chat Support on the same Whatsapp Number", "img": WtTheme.ImageBaseUrl + "/MultiAgent.svg" },
        { "t": "Broadcast Unlimited Campaigns", "d": "Broadcast Messages up to 1,00,000 users in one day", "img": WtTheme.ImageBaseUrl + "/BroadcastIcon.svg" },
        { "t": "Connect Your APIs", "d": "Easily Connect with Shopify, Salesforce, WooCommerce, Zapier, Payment Portals, CRMs & more", "img": WtTheme.ImageBaseUrl + "/API.svg" },
        { "t": "Connect no Code A.I. Chatbots", "d": "Connect No-Code Chatbots from Google Dialogflow in a Single Click", "img": WtTheme.ImageBaseUrl + "/Chatbots.svg" },
        { "t": "Import and Export Contacts", "d": "Import Opted-In Contacts and Broadcast Messages seamlessly", "img": WtTheme.ImageBaseUrl + "/ImportExport.svg" },
        { "t": "Template Messages Approvals", "d": "Quick Fast Template Message Approval Process (2-3 Days) via Interactive Dashboard", "img": WtTheme.ImageBaseUrl + "/ApprovalMsg.svg" },
        { "t": "Send Personalised Messages", "d": "Use User attributes effectively to send personalised campaigns", "img": WtTheme.ImageBaseUrl + "/PersonalizeMessage.svg" },
        { "t": "Chat CRM Included", "d": "Manage Contacts & Create segregated audience using various tags, attributes & more", "img": WtTheme.ImageBaseUrl + "/CRM.svg" }
    ]
    return (
        <Container className="mt-5 mb-5 pe-3 ps-3">
            <p className="mt-5 fw-bold" style={{ color: WtColor.TextDarkColor, fontSize: "24px" }}>Powerful  Features that you need</p>
            <p className="fw-bold" style={{ color: WtColor.TextMidGrey, fontSize: "12px" }}>All Plans of WhatsTool Business are Inclusive of these features</p>
            <div className="features mt-4 qg_one">
                <Row>
                    {
                        FeaturesData.map((v, i) => {
                            return (
                                <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} className="mb-2 p-3 hand" style={{ height: "auto" }} key={i}>
                                    <div className="rounded-3 p-4 quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <div style={{ display: "flex" }}>
                                            <p className="fw-bold" style={{ fontSize: "18px", width: "75%" }}>{v.t}</p>
                                            <p className="float-end"><img src={v.img} alt={WtTheme.SiteName} /></p>
                                        </div>
                                        <div>
                                            <p style={{ fontSize: "14px" }}>{v.d} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </div>

            <p className="mt-5 fw-bold" style={{ color: WtColor.TextDarkColor, fontSize: "24px" }}>Why Choose Whatsapp?</p>
            <p className="fw-bold" style={{ color: WtColor.TextMidGrey, fontSize: "12px" }}>Whatsapp is the One Platform that brings together Actionable Notifications &amp; Customer Support!</p>
            <div className="pt-5 mt-5 pb-5 rounded-3 quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                <Row>
                    <Col>
                        <div>
                            <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/OpenRate.svg"} alt={WtTheme.SiteName} /></p>
                            <p className="text-center fw-bold" style={{ color: WtColor.TextDarkColor }}>95% Open Rates</p>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/ClickRate.svg"} alt={WtTheme.SiteName} /></p>
                            <p className="text-center fw-bold" style={{ color: WtColor.TextDarkColor }}>45-60% Click Rates</p>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/2BnUser.svg"} alt={WtTheme.SiteName} /></p>
                            <p className="text-center fw-bold" style={{ color: WtColor.TextDarkColor }}>2 Bn+ Users</p>
                        </div>
                    </Col>
                </Row>
            </div>
            <p className="text-center mt-4 "><Link to={WtUrl.signupUrl}><button className="btn btn-sm theme_bg text-white mb-5 pt-3 pb-3 ps-5 pe-5 bRound" style={{ fontSize: "20px" }}>Get Started Now</button></Link></p>

            <p className="mt-5 fw-bold" style={{ color: WtColor.TextDarkColor, fontSize: "24px" }}>Experience Whatsapp Smart Notifications Now</p>
            <p className="fw-bold" style={{ color: WtColor.TextMidGrey, fontSize: "12px" }}>Which Notification would you like to Experience? Choose one &amp; we will send it instantly on your Whatsapp</p>
            <div className="pb-5 mt-5 qg_two">
                <Row>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} >
                        <div className="quick_features" style={{ borderRadius: "6px", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div >
                                <div className="p-3">
                                    <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/Cart.svg"} alt={WtTheme.SiteName} /></p>
                                </div>
                            </div>
                            <p style={{ borderRadius: "0px 0px 6px 6px" }} className="text-center theme_bg text-white p-2">Abandoned Cart Recovery</p>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} >
                        <div className="quick_features" style={{ borderRadius: "6px", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div>
                                <div className="p-3">
                                    <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/OrderCart.svg"} alt={WtTheme.SiteName} /></p>
                                </div>
                            </div>
                            <p style={{ borderRadius: "0px 0px 6px 6px" }} className="text-center theme_bg text-white p-2">Order Confirmation</p>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} >
                        <div className="quick_features" style={{ borderRadius: "6px", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div>
                                <div className="p-3">
                                    <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/Feedback.svg"} alt={WtTheme.SiteName} /></p>
                                </div>
                            </div>
                            <p style={{ borderRadius: "0px 0px 6px 6px" }} className="text-center theme_bg text-white p-2">Feedback Offer Loop</p>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} >
                        <div className="quick_features" style={{ borderRadius: "6px", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div>
                                <div className="p-3">
                                    <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/Product.svg"} alt={WtTheme.SiteName} /></p>
                                </div>
                            </div>
                            <p style={{ borderRadius: "0px 0px 6px 6px" }} className="text-center theme_bg text-white p-2">Product Details</p>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} >
                        <div className="quick_features" style={{ borderRadius: "6px", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div>
                                <div className="p-3">
                                    <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/Course.svg"} alt={WtTheme.SiteName} /></p>
                                </div>
                            </div>
                            <p style={{ borderRadius: "0px 0px 6px 6px" }} className="text-center theme_bg text-white p-2">Course Application Reminder</p>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6} >
                        <div className="quick_features" style={{ borderRadius: "6px", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div>
                                <div className="p-3">
                                    <p className="text-center"><img src={WtTheme.ImageBaseUrl + "/Event.svg"} alt={WtTheme.SiteName} /></p>
                                </div>
                            </div>
                            <p style={{ borderRadius: "0px 0px 6px 6px" }} className="text-center theme_bg text-white p-2">Event Reminder</p>
                        </div>
                    </Col>
                </Row >
            </div>

            <p className="mt-5 fw-bold" style={{ color: WtColor.TextDarkColor, fontSize: "24px" }}>Get WhatsApp Business API in 10 Minutes</p>
            <div className="qg_three">
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="p-5 images">
                            <img src={WtTheme.ImageBaseUrl + "/GreenTick.png"} className="img-fluid" alt={WtTheme.SiteName} />
                        </div>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="p-5 text">
                            <p>WhatsTool Perform is powered by Official Whatsapp Business APIs and is in alignment with all Whatsapp Rules.</p>
                            <p>Get Verified Green Tick on your Whatsapp Broadcast upto 100,000 Notifications 24*7 Chat Support by WhatsTool Team</p>
                            <p className="mt-4 "><Link to={WtUrl.signupUrl}><button className="btn btn-sm theme_bg text-white mb-5 pt-1 pb-1 ps-3 pe-3 bRound" style={{ fontSize: "15px" }}>Apply Now</button></Link></p>
                        </div>
                    </Col>
                </Row>
            </div>


            <p className="text-center fw-bold mt-5 pt-5" style={{ color: WtColor.TextDarkColor, fontSize: "24px" }}>Official WhatsApp API Key-Points</p>
            <div className="key-points mt-5 hand">
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                        <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div className="theme_bg p-3 text-white fw-bold">
                                <ul>
                                    <li>Pre-requisites for Official WhatsAPP</li>
                                    <li>Documents and other requirements to get an Official WhatsApp API account created.</li>
                                </ul>
                            </div>
                            <div className="bg-white p-4" style={{ lineHeight: "2.15" }}>
                                <p>You will need the following to get started:</p>
                                <ol>
                                    <li>Email,</li>
                                    <li>Live website URL,</li>
                                    <li>Facebook account,</li>
                                    <li>A mobile number that has never been previously used on WhatsApp,</li>
                                    <li>Company formation document available in your country,</li>
                                    <li>Company address proof document such as tax certificate etc.</li>
                                </ol>
                            </div>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                        <div>
                            <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <div className="theme_bg p-3 text-white fw-bold">
                                    <ul>
                                        <li>Can I send any kind of message using official WhatsApp account?</li>
                                    </ul>
                                </div>
                                <div className="bg-white p-4">
                                    <p>You can send any kind of image, video, document message with official WhatsApp account, but please do note that you need to get the message template approved from WhatsApp first using our panel. Template approval takes around 5 mins to up to 24 hours duration.</p>
                                </div>
                            </div>
                            <div className="mt-2 quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <div className="theme_bg p-3 text-white fw-bold">
                                    <ul>
                                        <li>Set-up Charge</li>
                                    </ul>
                                </div>
                                <div className="bg-white p-4">
                                    <p>Completely free</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12}>
                        <div>
                            <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <div className="theme_bg p-3 text-white fw-bold">
                                    <ul>
                                        <li>Verified Green Tick</li>
                                    </ul>
                                </div>
                                <div className="bg-white p-4">
                                    <p>Yes. But green-tick verification is subject to Facebook policies. Check your business eligibility for Green-tick verification here.</p>
                                </div>
                            </div>
                            <div className="mt-2 quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <div className="theme_bg p-3 text-white fw-bold">
                                    <ul>
                                        <li>Banning of Numbers</li>
                                    </ul>
                                </div>
                                <div className="bg-white p-4">
                                    <p>No, the number will not get banned unless reported or blocked by a significantly large number of users for several consecutive days.</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div className="theme_bg p-3 text-white fw-bold">
                                <ul>
                                    <li>Number of WhatsApp messages per day</li>
                                </ul>
                            </div>
                            <div className="bg-white p-4" style={{ lineHeight: "2.15" }}>
                                <p className="text-center" >
                                    <img src={WtTheme.ImageBaseUrl + "/quickGuide_01.png"} alt={WtTheme.SiteName} style={{ height: "150px" }} className="img-fluid w-75" />
                                </p>
                            </div>
                        </div>
                        <Row className="mt-3">
                            <Col>
                                <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                    <div className="theme_bg p-3 text-white fw-bold">
                                        <ul>
                                            <li>Set-up Time</li>
                                        </ul>
                                    </div>
                                    <div className="bg-white p-3">
                                        <p>Application is processed immediately. Approval from Facebook may take 1-5 days.</p>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                    <div className="theme_bg p-3 text-white fw-bold">
                                        <ul>
                                            <li>How it works</li>
                                        </ul>
                                    </div>
                                    <div className="bg-white p-3">
                                        <p>Use Contact Management and Campaign Management to send bulk messages.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <div className="quick_features" style={{ boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <div className="theme_bg p-3 text-white fw-bold">
                                <ul>
                                    <li>Per message charge</li>
                                    <li>Meta, parent company of WhatsApp charges message cost and it needs to be paid to them.</li>
                                </ul>
                            </div>
                            <div className="bg-white p-4" style={{ lineHeight: "2.15" }}>
                                <Table className="fw-bold" responsive>
                                    <thead style={{ background: WtColor.CloudyGrey, color: WtColor.TextDarkColor }}>
                                        <tr>
                                            <th>Country</th>
                                            <th>Business-initiated Rate</th>
                                            <th>User-initiated Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ background: WtColor.LineColor, color: WtColor.TextMidGrey }}>
                                        <tr>
                                            <td>India</td>
                                            <td>₹ 0.4843</td>
                                            <td>₹ 0.2906</td>
                                        </tr>
                                        <tr>
                                            <td>USA</td>
                                            <td>₹ 1.0768</td>
                                            <td>₹ 0.6461</td>
                                        </tr>
                                        <tr>
                                            <td>Indonesia</td>
                                            <td>₹ 2.3151</td>
                                            <td>₹ 1.3890</td>
                                        </tr>
                                        <tr>
                                            <td>Brazil</td>
                                            <td>₹ 3.6646</td>
                                            <td>₹ 2.1987</td>
                                        </tr>
                                        <tr>
                                            <td>Malaysia</td>
                                            <td>₹ 5.3655</td>
                                            <td>₹ 1.6096</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='mt-5'>
                <h3 style={{ color: WtColor.TextDarkColor, marginTop: "100px" }}>360Dialog vs WhatsApp Cloud API</h3>
                <Table className="fw-bold w-75" responsive>
                    <thead style={{ background: WtColor.LineColor, color: WtColor.TextLightGrey }}>
                        <tr>
                            <th>360Dialog</th>
                            <th>WhatsApp Cloud API</th>
                        </tr>
                    </thead>
                    <tbody style={{ background: "#fff", fontSize: "14px" }}>
                        <tr>
                            <td>Mandatory to Recharge after 1000 message in all plan except in Free plan (after 500 message)</td>
                            <td>Mandatory to Recharge after 1000 message in all plan except in Free plan (after 500 message)</td>
                        </tr>
                        <tr>
                            <td>Security Deposit of Rs 2000 is mandatory at the start of plan. It will be refunded at the end if you inform about your removal of account before 60 days.</td>
                            <td>No security Deposit Required</td>
                        </tr>
                        <tr>
                            <td>Recharge will include WhatsApp charges. For  Example for Recharge of Rs1000 user will get 1800 BIC = 1700x0.49(BIC) + 0.10 (WTB platform free)x1700</td>
                            <td>Recharge will not include WhatsApp charges & will only be our platform fee.<br />For Example for Recharge of Rs1000 user will be able to send 10,000 messages because we will only charge platform free</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </Container >
    )
}
// End of Quick Guide Page UI



// Integeration Page UI
export const Integeration = () => {
    return (
        <div>
            <IntegrationInfo />
            <ECommerceIntegrations />
            <CRMAgentIntegrations />
            <PaymentIntegrations />
            <Appintegrations />
        </div>
    )
}
export const IntegrationInfo = () => {
    const s1 = { fontSize: "35px", color: '#273041' }
    const s2 = { color: '#616874', fontSize: '21px' }
    return (
        <div>
            <Container>
                <Row>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                        <div className='mt-5'>
                            <p style={s1} className="fw-semibold him_fs">Reach many WhatsApp users by seamlessly integrating your existing systems with WhatsTool Business</p>
                            <p style={s2} className="him_fsx">Give your customers best experience and personalisation. By integrating your databases and third party tools with WhatsTool Business, you can provide a superior experience to both your customers and agents.</p>
                        </div>
                    </Col>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} >
                        <div className='mt-5 float-end'>
                            <img src={WtUrl.imageBaseUrl + '/inte_01.png'} alt='Whatstool Business' className='img-fluid' />

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export const ECommerceIntegrations = () => {
    const s1 = { color: '#00A82D', fontSize: '30px' }
    const s2 = { color: '#616874', fontSize: '21px' }

    return (
        <div>
            <Container>
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} >
                        <div className='mt-5 pt-5'>
                            <p style={s1} className="fw-semibold him_fs">E-Commerce Integrations</p>
                            <p style={s2} className="him_fsx">Integrate your favourite E -Commerce apps to reduce abandoned carts, increase revenues with one click integrations</p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                        <div className='mt-5 pt-5 float-end '>
                            <img src={WtUrl.imageBaseUrl + '/inte_02.png'} alt='Whatstool Business' className='img-fluid' />

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export const CRMAgentIntegrations = () => {
    const s1 = { background: "#F8FBF7" }
    const s2 = { marginTop: "90px" }
    const s3 = { width: "560px" }
    const s4 = { color: '#00A82D', fontSize: '30px' }
    const s5 = { color: '#616874', fontSize: '21px' }

    return (
        <div>
            <Container fluid style={s1}>
                <Container>
                    <Row style={s2}>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                            <div className='pb-5 pt-5'>
                                <img src={WtUrl.imageBaseUrl + '/inte_03.png'} alt='Whatstool Business' style={s3} className='him_wt' />

                            </div>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} >
                            <div className='pb-5 pt-5'>
                                <p style={s4} className="fw-semibold pt-5 him_fs">CRM & Agent Integrations</p>
                                <p style={s5} className="him_fsx">Integrate your existing CRM & live Agent apps to engage with your customer better</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
export const PaymentIntegrations = () => {
    const s1 = { color: '#00A82D', fontSize: '30px' }
    const s2 = { color: '#616874', fontSize: '21px' }
    const s3 = { width: "471px" }

    return (
        <div>
            <Container>
                <Row>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} >
                        <div className='mt-5 pt-5'>
                            <p style={s1} className="fw-semibold him_fs">Payment Integrations</p>
                            <p style={s2} className="him_fsx">Integrate with easily accessible payment gateways and enable easy payment for your customer without switching between the channels</p>
                        </div>
                    </Col>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                        <div className='mt-5 pt-5 float-end '>
                            <img src={WtUrl.imageBaseUrl + '/inte_04.png'} alt='Whatstool Business' style={s3} className='him_wt' />

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export const Appintegrations = () => {
    const history = useHistory()
    const s3 = { cursor: "pointer" }
    // const s8 = { background: "#92cc37" }
    const s9 = { color: "#9EA4B5" }
    const s10 = { fontSize: "19px" }
    const s11 = { background: WtColor.CloudyGrey, width: "100%", height: "40px", position: "absolute", bottom: "0" }
    const s1 = { fontSize: '32px' }
    const s2 = { color: "#9EA4B5", fontSize: "18px" }
    const appintegrationsSchema = [
        { image: WtUrl.imageBaseUrl + '/inte_zoho.png', info: 'CRM Plateform', description: 'Integrate messages on the Zoho CRM', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_shopify.png', info: 'E-commerce Platform', description: 'Chat Widget, Cart Abandonment Emails, etc.', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_walink.png', info: 'Messaging Platform', description: 'Create shareable links & QR  for your WA business number', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_pably.png', info: 'Online Marketing & Sales Plateform', description: 'Automate or link with 700+ apps throgh pabbly Connect', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_zapier.png', info: 'Connect Platform', description: 'Send an approved template WhatsApp message', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_razorpay.png', info: 'Payment Provider', description: 'Integrate messages on the Razorpay', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_woocom.png', info: 'E-commerce Platform', description: 'Chat Widget, Cart Abandonment Emails, etc.', btnText: 'Coming Soon', bottambtntext: 'Connect' },
        { image: WtUrl.imageBaseUrl + '/inte_hubspot.png', info: 'CRM Platform', description: 'Integrate messages on the Hubspot CRM', btnText: 'Coming Soon', bottambtntext: 'Connect' },
    ]
    return (
        <div>
            <Container className="mb-5">
                <Row>
                    <div className='mt-5 '>
                        <p className='fw-semibold him_fs' style={s1}>App Integration </p>
                        <p style={s2} className="him_fsx">Connect WhatsTool Business to your favorite services</p>
                    </div>
                    {
                        appintegrationsSchema?.map((v, i) => {
                            return (
                                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} key={i}>
                                    <div className='him_boxshadow rounded-3 mt-5' style={s3}>
                                        <div className='p-4'>
                                            <img src={v.image} alt='whatstool business' classname='img-fluid' />
                                            {/* <button className="btn btn-sm me-2 text-white rounded-5 float-end" style={s8}>{v.btnText}</button> */}

                                            <p style={s9} className='fw-semibold pt-2'>{v.info}</p>
                                            <p className='pt-4 fw-semibold' style={s10}> {v.description}</p>
                                        </div>

                                        <button className="btn btn-sm mt-4 text-white fw-bold" onClick={() => history.push(WtUrl.signupUrl)} style={s11}>{v.bottambtntext}</button>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}
// End of Integeration Page UI



// Educational Industry Sector UI by Himanshu
export const EducationalSector = () => {
    return (
        <>
            <EducationInfo />
            <Container className="clients" fluid><Client /></Container>
            <EducationsectionOne />
            <EducationsectionTwo />
            <EducationsectionThree />
            <EducationsectionFour />
            <EducationsectionFive />
            <EducationsectionSix />
            <EducationsectionSeven />
            <EducationsectionFooter />
            <Container><Testimonial /></Container>
        </>
    )
}
export const EducationInfo = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "50px" }
    const s2 = { fontSize: "46px" }
    const s3 = { fontSize: "26px", color: "gray" }
    return (
        <div>
            <Container>
                <Row>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                        <div className="mt-5">
                            <p style={s2} className='fw-semibold him_FSize'>WhatsTool Business for Education Institutions</p>
                            <p style={s3} className='mt-4 him_FSIZE'>From Admit, Onboard, Engage, Give Updates, Solve Queries to Customer Support it helps Educational Institutions improve Admission Rates</p>
                            <p>
                                <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)} >Get Started</button>
                            </p>
                        </div>

                    </Col>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} col={12} >
                        <div className="mt-5 mb-5 float-end">
                            <img src={WtUrl.imageBaseUrl + '/edu_01.png'} alt={WtString.SiteName} className="img-fluid ps-4 pe-5" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export const EducationsectionOne = () => {

    const s1 = { marginTop: "300px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_MARGIN'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Take Admission on WhatsApp</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Allow your students to view the course details and choose the course and get admitted from WhatsApp only.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/edu_02.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EducationsectionTwo = () => {

    const s1 = { marginTop: "345px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <div style={s4}>
            <Container fluid>
                <Container>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="">
                                <img src={WtUrl.imageBaseUrl + '/edu_03.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                            </div>
                        </Col>

                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div style={s1} className='him_MARGIN'>
                                <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Online Parent Teacher Meeting</p>
                                <p style={s3} className='fw-semibold him_FONTsize'>Move parents teachers meeting online. Share regular class updates with them, with progress reports and more.</p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
export const EducationsectionThree = () => {

    const s1 = { marginTop: "340px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Share Important Notification & Updates</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Inform students about upcoming events, class schedules, Exam Time Tables.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center">
                        <img src={WtUrl.imageBaseUrl + '/edu_04.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EducationsectionFour = () => {
    const s1 = { marginTop: "245px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }
    return (
        <div style={s4}>
            <Container fluid>
                <Container>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="pt-5 pb-5 mb-5">
                                <img src={WtUrl.imageBaseUrl + '/edu_05.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                            </div>
                        </Col>

                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div style={s1} className='him_MT pb-5'>
                                <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Collect Feedback from Students</p>
                                <p style={s3} className='fw-semibold him_FONTsize'>Use WhatsApp to collect feedback from students and parents. See higher response rate.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
export const EducationsectionFive = () => {
    const s1 = { marginTop: "275px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Green Tick Mark</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Get green tick for your Education Institute in WhatsApp, make it official and allow people to trust you more.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/edu_06.png'} alt={WtString.SiteName} className="img-fluid p-5" />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EducationsectionSix = () => {

    const s4 = { background: '#F8FBF7' }
    const s2 = { fontSize: '40px', color: '#00A82D' }

    return (
        <div style={s4}>
            <Container fluid>
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                            <div className="text-center">
                                <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Team Chat to answer Student, Parent and Faculty queries by assigning people for that particular task</p>
                                <p className="pb-5">
                                    <img src={WtUrl.imageBaseUrl + '/edu_07.png'} alt={WtString.SiteName} className="img-fluid" />
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
export const EducationsectionSeven = () => {

    const s2 = { fontSize: '40px', color: '#00A82D' }

    return (
        <Container>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                    <div className="text-center">
                        <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Broadcast to send messages to 1000+ people at a time</p>
                        <p className="pb-4">
                            <img src={WtUrl.imageBaseUrl + '/edu_08.png'} alt={WtString.SiteName} className="img-fluid" />
                        </p>
                    </div>
                </Col>
            </Row>
        </Container >
    )
}
export const EducationsectionFooter = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "20px" }
    const s4 = { background: '#F8FBF7' }
    return (
        <div className="pt-5 pb-4" style={s4}>
            <Container fluid >
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                            <div className="text-center">
                                <p className="fw-semibold pb-4 him_fontSIZE" style={{ fontSize: '32px' }}>Use WhatsTool Business as a solution for your Business Growth</p>
                                <p className="him_fontSIZE" style={{ fontSize: '32px', color: 'gray' }}>Solve students queries 24*7 and engage with the students throughout their journey without any human effort and increase your sales</p>
                                <p className="pt-4 fw-semibold him_fontSIZE" style={{ fontSize: '30px' }}>You can do it with zero cost</p>
                                <p>
                                    <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
// End of Educational Industry Sector UI by Himanshu



// ECommerce Industry Sector UI by Himanshu
export const ECommerceSector = () => {
    return (
        <>
            <EcommerceInfo />
            <Container className="clients" fluid><Client /></Container>
            <EcommercesectionOne />
            <EcommercesectionTwo />
            <EcommercesectionThree />
            <EcommercesectionFour />
            <EcommercesectionFive />
            <EcommercesectionSix />
            <EcommercesectionSeven />
            <EcommercesectionFooter />
            <Container><Testimonial /></Container>
        </>
    )
}
export const EcommerceInfo = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "50px" }
    const s2 = { fontSize: "46px" }
    const s3 = { fontSize: "26px", color: "gray" }
    return (
        <div>
            <Container>
                <Row>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                        <div className="mt-5">
                            <p style={s2} className='fw-semibold him_FSize'>WhatsTool Business for E-commerce</p>
                            <p style={s3} className='mt-4 him_FSIZE'>Promote Your products, share catalogs, receive orders online and provide customer support 24/7</p>
                            <p>
                                <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                            </p>
                        </div>

                    </Col>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} col={12} >
                        <div className="mt-5 mb-5 float-end">
                            <img src={WtUrl.imageBaseUrl + '/ecom_01.png'} alt={WtString.SiteName} className="img-fluid ps-4 pe-5" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export const EcommercesectionOne = () => {
    const s1 = { marginTop: "300px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_MARGIN'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Take Orders on WhatsApp</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Allow your customers to view your shop catalog, place orders, track shipments, cancel and edit items all from WhatsApp only.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/ecom_02.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EcommercesectionTwo = () => {
    const s1 = { marginTop: "275px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="pt-5 pb-5">
                            <img src={WtUrl.imageBaseUrl + '/ecom_03.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div style={s1} className='him_MARGIN'>
                            <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Recover Abandoned Carts on WhatsApp</p>
                            <p style={s3} className='fw-semibold him_FONTsize'>Many times user will add the products to the cart and forget to order. Send a reminder on whatsApp in which through a single click it takes them to the checkout page.</p>

                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const EcommercesectionThree = () => {
    const s1 = { marginTop: "310px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Customer Support on WhatsApp</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Provide 24*7 customer support on WhatsApp without any human dependancy and without any delay in the service.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/ecom_04.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EcommercesectionFour = () => {
    const s1 = { marginTop: "260px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="pt-5 pb-5 mt-5 mb-5">
                            <img src={WtUrl.imageBaseUrl + '/ecom_05.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div style={s1} className='him_MT'>
                            <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Collect Ratings & Reviews on WhatsApp</p>
                            <p style={s3} className='fw-semibold him_FONTsize'>Use WhatsApp to collect reviews, ratings and feedback personally.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const EcommercesectionFive = () => {
    const s1 = { marginTop: "255px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Green Tick Mark</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Get green tick for your business in WhatsApp, make your business official and allow your customer to trust you more.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 pb-5">
                        <img src={WtUrl.imageBaseUrl + '/ecom_06.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EcommercesectionSix = () => {
    const s4 = { background: '#F8FBF7' }
    const s2 = { fontSize: '40px', color: '#00A82D' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="text-center">
                            <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Team Chat for patient support by assigning people for that particular task </p>
                            <p className="pb-5">
                                <img src={WtUrl.imageBaseUrl + '/ecom_07.png'} alt={WtString.SiteName} className="img-fluid" />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const EcommercesectionSeven = () => {
    const s2 = { fontSize: '40px', color: '#00A82D' }
    return (
        <Container>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>

                    <div className="text-center">
                        <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Broadcast to send messages to 1000+ people at a time </p>
                        <p className="pb-4">
                            <img src={WtUrl.imageBaseUrl + '/ecom_08.png'} alt={WtString.SiteName} className="img-fluid" />
                        </p>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const EcommercesectionFooter = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "20px" }
    const s4 = { background: '#F8FBF7' }
    return (
        <Container className="pt-5 pb-4" style={s4} fluid >
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="text-center">
                            <p className="fw-semibold pb-4 him_fontSIZE" style={{ fontSize: '32px' }}>Use WhatsTool Business as a solution for your Business Growth</p>
                            <p className="him_fontSIZE" style={{ fontSize: '32px', color: 'gray' }}>Provide 24*7 customer support and engage with the customers throughout their journey without any human effort and increase your sales</p>
                            <p className="pt-4 fw-semibold him_fontSIZE" style={{ fontSize: '30px' }}>You can do it with zero cost</p>
                            <p>
                                <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
// End of ECommerce Industry Sector UI by Himanshu



// Health Industry Sector UI by Himanshu
export const HealthSector = () => {
    return (
        <>
            <HealthInfo />
            <Container className="clients" fluid><Client /></Container>
            <HealthsectionOne />
            <HealthsectionTwo />
            <HealthsectionThree />
            <HealthsectionFour />
            <HealthsectionFive />
            <HealthsectionSix />
            <HealthsectionSeven />
            <HealthsectionEight />
            <HealthsectionFooter />
            <Container><Testimonial /></Container>
        </>
    )
}
export const HealthInfo = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "50px" }
    const s2 = { fontSize: "46px" }
    const s3 = { fontSize: "26px", color: "gray" }
    return (
        <div>
            <Container>
                <Row>
                    <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                        <div className="mt-5">
                            <p style={s2} className='fw-semibold him_FSize'>WhatsTool Business for Healthcare & Medicals</p>
                            <p style={s3} className='mt-4 him_FSIZE'>Go the extra mile by providing your patients and customers the ability to reach out to you 24/7 and at every step of their journey</p>
                            <p>
                                <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                            </p>
                        </div>

                    </Col>
                    <Col xxl={5} xl={5} lg={5} md={5} sm={12} col={12} >
                        <div className="mt-5 mb-5 float-end">
                            <img src={WtUrl.imageBaseUrl + '/heath_01.png'} alt={WtString.SiteName} className="img-fluid ps-4 pe-5" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export const HealthsectionOne = () => {

    const s1 = { marginTop: "300px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_MARGIN'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Take Appointment on WhatsApp</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Allow your patient to view the available doctor details and choose the timings and get appointment from WhatsApp only.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/heath_02.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const HealthsectionTwo = () => {

    const s1 = { marginTop: "275px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="pt-5 pb-5">
                            <img src={WtUrl.imageBaseUrl + '/heath_03.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div style={s1} className='him_MARGIN'>
                            <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Automated Appointment Reminders</p>
                            <p style={s3} className='fw-semibold him_FONTsize'>Send your customers timely reminders for their appointments to ensure that they never miss appointment.</p>

                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const HealthsectionThree = () => {

    const s1 = { marginTop: "310px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Sample & Report Collection Notifications</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Send notifications to remind patients to collect samples and reports from your clinic or hospital.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center pt-2 pb-2 mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/heath_04.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const HealthsectionFour = () => {

    const s1 = { marginTop: "260px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="pt-5 pb-5 ">
                            <img src={WtUrl.imageBaseUrl + '/heath_05.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div style={s1} className='him_MARGIN'>
                            <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Post Consultation Follow Up</p>
                            <p style={s3} className='fw-semibold him_FONTsize'>You can send post - consultation follow ups to check in on your patients. It helps you provide that personal touch.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const HealthsectionFive = () => {

    const s1 = { marginTop: "255px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Collect Feedback from Patients</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Use WhatsApp to collect feedback from patients about the treatment and hospital. See higher response rate.</p>
                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center pt-5 pb-5 mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/heath_06.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const HealthsectionSix = () => {

    const s1 = { marginTop: "140px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="mt-5 mb-5 pb-5">
                            <img src={WtUrl.imageBaseUrl + '/heath_07.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div style={s1} className='him_MARGIN'>
                            <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Green Tick Mark</p>
                            <p style={s3} className='fw-semibold him_FONTsize'>Get green tick for your Hospital in WhatsApp, make it official and allow people to trust you more.</p>

                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const HealthsectionSeven = () => {

    const s2 = { fontSize: '40px', color: '#00A82D' }

    return (
        <Container>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                    <div className="text-center">
                        <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Team Chat to answer Patient and Faculty queries by assigning people for that particular task </p>
                        <p className="pb-5">
                            <img src={WtUrl.imageBaseUrl + '/heath_08.png'} alt={WtString.SiteName} className="img-fluid" />
                        </p>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const HealthsectionEight = () => {

    const s2 = { fontSize: '40px', color: '#00A82D' }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                        <div className="text-center">
                            <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Broadcast to send messages to 1000+ people at a time</p>
                            <p className="pb-4">
                                <img src={WtUrl.imageBaseUrl + '/heath_09.png'} alt={WtString.SiteName} className="img-fluid" />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>

    )
}
export const HealthsectionFooter = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "20px" }
    const s4 = { background: '#F8FBF7' }
    return (
        <Container className="pt-5 pb-4" style={s4} fluid >
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                        <div className="text-center">
                            <p className="fw-semibold pb-4 him_fontSIZE" style={{ fontSize: '32px' }}>Use WhatsTool Business as a solution for your Business Growth</p>
                            <p className="him_fontSIZE" style={{ fontSize: '32px', color: 'gray' }}>Solve students queries 24*7 and engage with the students throughout their journey without any human effort and increase your sales</p>
                            <p className="pt-4 fw-semibold him_fontSIZE" style={{ fontSize: '30px' }}>You can do it with zero cost</p>
                            <p>
                                <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
// End of Health Industry Sector UI by Himanshu



// Tour Travel Industry Sector UI by Himanshu
export const TourTravelSector = () => {
    return (
        <>
            <TravelInfo />
            <Container className="clients" fluid><Client /></Container>
            <TravelsectionOne />
            <TravelsectionTwo />
            <TravelsectionThree />
            <TravelsectionFour />
            <TravelsectionFive />
            <TravelsectionSix />
            <TravelsectionSeven />
            <TravelsectionEight />
            <TravelsectionNine />
            <TravelsFooter />
            <Container><Testimonial /></Container>
        </>
    )
}
export const TravelInfo = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "50px" }
    const s2 = { fontSize: "46px" }
    const s3 = { fontSize: "26px", color: "gray" }
    return (
        <Container>
            <Row>
                <Col xxl={7} xl={7} lg={7} md={7} sm={12} xs={12} >
                    <div className="mt-5">
                        <p style={s2} className='fw-semibold him_FSize'>WhatsTool Business for Tours & Travels</p>
                        <p style={s3} className='mt-4 him_FSIZE'>Assist, Coordinate, Recommend & Plan for your customers journey and make it a perfect trip by providing customer support 24/7</p>
                        <p>
                            <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                        </p>
                    </div>

                </Col>
                <Col xxl={5} xl={5} lg={5} md={5} sm={12} col={12} >
                    <div className="mt-5 mb-5">
                        <p className="text-center">
                            <img src={WtUrl.imageBaseUrl + '/tt_01.png'} alt={WtString.SiteName} className="img-fluid ps-4 pe-5" />
                        </p>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const TravelsectionOne = () => {

    const s1 = { marginTop: "190px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_MARGIN'>
                        <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Assist Bookings on WhatsApp</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Allow your customer to book, modify and cancel it from WhatsApp only.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-5 mb-5">
                        <img src={WtUrl.imageBaseUrl + '/tt_02.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const TravelsectionTwo = () => {

    const s1 = { marginTop: "135px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <div style={s4} >
            <Container fluid>
                <Container>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="pt-5 pb-5">
                                <img src={WtUrl.imageBaseUrl + '/tt_03.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                            </div>
                        </Col>

                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div style={s1} className='pb-5 him_MARGIN'>
                                <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Automated Booking Reminders</p>
                                <p style={s3} className='fw-semibold him_FONTsize'>Send your customers timely reminders of their bookings to ensure that they never miss or be late for the trip.</p>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
export const TravelsectionThree = () => {

    const s1 = { marginTop: "175px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2  him_FONTSIZE'>Make Repeat Customers</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Provide customers a memorable and delightful experiences so that they come back again.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center mt-4 mb-4">
                        <img src={WtUrl.imageBaseUrl + '/tt_04.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const TravelsectionFour = () => {

    const s1 = { marginTop: "175px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }

    return (
        <Container style={s4} fluid>
            <Container>
                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div className="pt-5 pb-5 ms-5 ">
                            <img src={WtUrl.imageBaseUrl + '/tt_05.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <div style={s1} className='pb-5 him_mar_tOP'>
                            <p style={s2} className='fw-semibold pb-2  him_FONTSIZE'>Provide Customer Support 24/7</p>
                            <p style={s3} className='fw-semibold him_FONTsize'>You can solve your customers queries 24/7 without any human dependancy by using chatbot.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}
export const TravelsectionFive = () => {

    const s1 = { marginTop: "175px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mar_tOP'>
                        <p style={s2} className='fw-semibold pb-2  him_FONTSIZE'>Share Exciting Deals and Offers</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Send your customers about the current deals and offers with the personalised message.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="text-center pt-2 pb-2 mt-5 mb-5">

                        <img src={WtUrl.imageBaseUrl + '/tt_06.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const TravelsectionSix = () => {

    const s1 = { marginTop: "125px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }
    const s4 = { background: '#F8FBF7' }


    return (
        <div style={s4}>
            <Container fluid>
                <Container>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div className="  mt-5 mb-5">
                                <img src={WtUrl.imageBaseUrl + '/tt_07.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                            </div>
                        </Col>

                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <div style={s1} className='pb-5 him_MT'>
                                <p style={s2} className='fw-semibold pb-2 him_FONTSIZE'>Collect Customer Reviews</p>
                                <p style={s3} className='fw-semibold him_FONTsize'>Use WhatsApp to collect reviews and feedback from your customers.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>

    )
}
export const TravelsectionSeven = () => {

    const s1 = { marginTop: "205px" }
    const s2 = { fontSize: "32px" }
    const s3 = { fontSize: "24px", color: "gray" }

    return (
        <Container>
            <Row>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div style={s1} className='him_mtt'>
                        <p style={s2} className='fw-semibold pb-2  him_FONTSIZE'>Green Tick Mark</p>
                        <p style={s3} className='fw-semibold him_FONTsize'>Get green tick for your Business in WhatsApp, make it official and allow people to trust you more.</p>

                    </div>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="mt-5 mb-5 pb-5">
                        <img src={WtUrl.imageBaseUrl + '/tt_08.png'} alt={WtString.SiteName} className="img-fluid p-5" />

                    </div>
                </Col>

            </Row>
        </Container>
    )
}
export const TravelsectionEight = () => {

    const s4 = { background: '#F8FBF7' }
    const s2 = { fontSize: '40px', color: '#00A82D' }

    return (
        <div style={s4}>
            <Container fluid>
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                            <div className="text-center">
                                <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Team Chat for customer support by assigning people for that particular task</p>
                                <p className="pb-5">
                                    <img src={WtUrl.imageBaseUrl + '/tt_09.png'} alt={WtString.SiteName} className="img-fluid" />
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
export const TravelsectionNine = () => {

    const s2 = { fontSize: '40px', color: '#00A82D' }

    return (
        <Container>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                    <div className="text-center">
                        <p className=" pt-5 pb-5 fw-semibold him_fontSIZE" style={s2}>Use Broadcast to send messages to 1000+ people at a time</p>
                        <p className="pb-4">
                            <img src={WtUrl.imageBaseUrl + '/tt_10.png'} alt={WtString.SiteName} className="img-fluid" />
                        </p>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export const TravelsFooter = () => {
    const history = useHistory()
    const s1 = { background: "#00A82D", borderRadius: "8px", border: "#00A82D", marginTop: "20px" }
    const s4 = { background: '#F8FBF7' }
    return (
        <div className="pt-5 pb-4" style={s4} >
            <Container fluid >
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                            <div className="text-center">
                                <p className="fw-semibold pb-4 him_fontSIZE" style={{ fontSize: '32px' }}>Use WhatsTool Business as a solution for your Business Growth</p>
                                <p className="him_fontSIZE" style={{ fontSize: '32px', color: 'gray' }}>Provide 24*7 customer support and engage with the customers throughout their journey without any human effort and increase your sales</p>
                                <p className="pt-4 fw-semibold him_fontSIZE" style={{ fontSize: '30px' }}>You can do it with zero cost</p>
                                <p>
                                    <button style={s1} className="btn btn-sm ps-5 pe-5 pt-2 pb-2 text-white fw-semibold" onClick={() => history.push(WtUrl.signupUrl)}>Get Started</button>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
// End of Tour Travel Industry Sector UI by Himanshu



// Team Page by Himanshu
export const TeamPage = () => {
    return (
        <div className='mt-4 mb-5 pb-5'>
            <TeamPageHeader />
            <TeamPageMission />
            <OurTeams />
            <OurStory />
        </div>
    )
}
export const TeamPageHeader = () => {
    return (
        <div style={{ display: "flex" }} className='him_flowroot'>
            <div style={{ background: '#EFFFED', flex: 1.75, padding: "95px" }} className='him_Paddig'>
                <p style={{ fontSize: "31px" }} className='fw-semibold him_sizing'>Empowering with the power of WhatsApp to Businesses </p>
                <p style={{ fontSize: "20px", color: "gray" }} className='pt-3 pe-5 him_Sizing'>for their growth in sales, marketing & customer support</p>
            </div>
            <div style={{ flex: 1.25 }}>
                <LazyLoadImage src={WtUrl.imageBaseUrl + '/group.webp'} style={{ height: '450px', width: '100%' }} alt='whatstool business' className='img-fluid' />
            </div>
        </div>
    )
}
export const TeamPageMission = () => {
    const OurAimbox = [
        { image: WtUrl.imageBaseUrl + '/our_aim_01.webp', info: 'Customers First', title: 'Delivering customers what they need is our first priority' },
        { image: WtUrl.imageBaseUrl + '/our_aim_02.webp', info: 'Providing Best', title: 'We always work hard to provide best for our customer in their growth' },
        { image: WtUrl.imageBaseUrl + '/our_aim_03.webp', info: 'Being Loyal', title: 'We always wish to gain customer’s trust and loyal' },
        { image: WtUrl.imageBaseUrl + '/our_aim_04.webp', info: 'Part of the Team', title: 'We always try to be the part of our customer’s team to solve the issue' }
    ]
    return (
        <div>
            <Container>
                <Row>
                    <div>
                        <p className='text-center fw-semibold mt-5 him_sizing' style={{ fontSize: "30px" }}>OUR MISSION</p>
                        <p style={{ fontSize: "20px", color: "gray" }} className='mt-5 him_Sizing'>We are in the mission to create the same impact for business that WhatsApp created for the users and businesses across the world. We want to empower business and teams with the tools for their growth in sales, support and marketing. Your growth is our mission.</p>
                        <p className='text-center fw-semibold him_sizing' style={{ fontSize: "30px", marginTop: '60px' }}>OUR AIM</p>

                    </div>
                    {
                        OurAimbox.map((v, i) => {
                            return (
                                <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} key={i}>
                                    <div className='mt-5 text-center mb-5 '>

                                        <LazyLoadImage src={v.image} alt='whatstool business' style={{ width: "100px", borderRadius: '2px' }} className='him_Boxsed ' />

                                        <p style={{ fontSize: "20px" }} className='fw-semibold him_sizedepen'>{v.info}</p>
                                        <p className='him_Sizing' style={{ color: "gray", fontSize: '15px' }}>{v.title}</p>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}
export const OurTeams = () => {
    const EmployeeIntro = [
        { empimage: WtUrl.imageBaseUrl + '/ashish.webp', name: 'Ashish Kumar', profilerole: 'Software Developer', socialimg1: WtUrl.imageBaseUrl + '/twitter.webp', socialimg2: WtUrl.imageBaseUrl + '/insta.webp', socialimg3: WtUrl.imageBaseUrl + '/in.webp', twitter: '', instagram: 'https://www.instagram.com/ak4344343/', linkedin: 'https://www.linkedin.com/in/ashish-kumar-6a7518186/' },

        { empimage: WtUrl.imageBaseUrl + '/mayank.webp', name: 'Mayank Kumar', profilerole: 'Software Developer', socialimg1: WtUrl.imageBaseUrl + '/twitter.webp', socialimg2: WtUrl.imageBaseUrl + '/insta.webp', socialimg3: WtUrl.imageBaseUrl + '/in.webp', instagram: '', twitter: '', linkedin: 'https://www.linkedin.com/in/mayank-uoi/' },
        { empimage: WtUrl.imageBaseUrl + '/madhushree.webp', name: 'Madhushree BJ', profilerole: 'UI/UX Designer', socialimg1: WtUrl.imageBaseUrl + '/twitter.webp', socialimg2: WtUrl.imageBaseUrl + '/insta.webp', socialimg3: WtUrl.imageBaseUrl + '/in.webp', twitter: '', instagram: 'https://www.instagram.com/madhushreebj/', linkedin: 'https://www.linkedin.com/in/madhushree-bj-680843180/' },
        { empimage: WtUrl.imageBaseUrl + '/animesh.webp', name: 'Animesh Dey', profilerole: 'Software Developer', socialimg1: WtUrl.imageBaseUrl + '/twitter.webp', socialimg2: WtUrl.imageBaseUrl + '/insta.webp', socialimg3: WtUrl.imageBaseUrl + '/in.webp', twitter: '', instagram: '', linkedin: 'https://www.linkedin.com/in/dey-animesh/' },
        { empimage: WtUrl.imageBaseUrl + '/suryanshu.webp', name: 'Suryanshu Raj', profilerole: 'Customer Success Manager', socialimg1: WtUrl.imageBaseUrl + '/twitter.webp', socialimg2: WtUrl.imageBaseUrl + '/insta.webp', socialimg3: WtUrl.imageBaseUrl + '/in.webp', twitter: 'https://twitter.com/SuryanshuRaj19', instagram: '', linkedin: 'https://www.linkedin.com/in/suryanshu-raj-18a31a21b/' },
        { empimage: WtUrl.imageBaseUrl + '/g6.webp', name: 'Subham Roy', profilerole: 'Customer Success Manager', socialimg1: WtUrl.imageBaseUrl + '/twitter.webp', socialimg2: WtUrl.imageBaseUrl + '/insta.webp', socialimg3: WtUrl.imageBaseUrl + '/in.webp', twitter: 'https://twitter.com/SuryanshuRaj19', instagram: '', linkedin: 'https://www.linkedin.com/in/suryanshu-raj-18a31a21b/' },
    ]

    const s1 = { fontSize: "22px", color: WtColor.BaseColor }
    const s2 = { fontSize: '18px', margin: '-20px 0px 0px 0px' }
    const s3 = { color: 'gray' }
    const s4 = { fontSize: '28px' }
    const s5 = { fontSize: '18px', color: 'gray', marginTop: '-15px' }
    return (
        <div className='mt-5 mb-5'>
            <Container>
                <Row>
                    <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} className='mb-5'>
                        <div>
                            <LazyLoadImage src={WtUrl.imageBaseUrl + '/ceo.webp'} alt='Whatstool Business' className='img-fluid p-3 ms-2' style={{ borderRadius: '24px' }} />
                        </div>
                    </Col>

                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12} className='mb-5'>
                        <div className='ms-5 mt-5'>
                            <p className='fw-semibold mt-3 mb-5 him_sizing' style={{ fontSize: "25px" }}>OUR TEAM</p>
                            <p style={s1} className='fw-semibold him_sizing'>“We are a team working together to empower each other through our work, skills and support in the growth of our clients.”</p><br />
                            <p style={s2} className='fw-bold him_Sizing'>Sujeet Kumar Mehta - <span style={s3} className='fw-semibold'>CEO & Founder</span>&nbsp;&nbsp;<span><Link to={{ pathname: 'https://www.linkedin.com/in/sujeetkumarmehta/' }} target='_blank'><LinkedIn style={{ fontSize: '22px', marginTop: '-6px', color: WtColor.TextLightGrey }} /></Link></span>  </p>
                        </div>
                    </Col>
                    {
                        EmployeeIntro.map((v, i) => {
                            return (
                                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} key={i}>
                                    <div className='mt-5 ms-5 me-5 mb-5'>
                                        <p className='text-center'>
                                            <LazyLoadImage src={v.empimage} alt="whatstool Business" className='img-fluid' style={{ height: '350px', borderRadius: '8px' }} />
                                        </p>
                                        <div className='text-center'>
                                            <p style={s4} className='fw-semibold him_sizing'>{v.name}</p>
                                            <p className='him_Sizing' style={s5}>{v.profilerole}</p>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}
export const OurStory = () => {
    const TeamGallery = [
        { image: WtUrl.imageBaseUrl + '/group_01.webp' },
        { image: WtUrl.imageBaseUrl + '/group_02.webp' },
        { image: WtUrl.imageBaseUrl + '/group_03.webp' },
        { image: WtUrl.imageBaseUrl + '/group_04.webp' },
        { image: WtUrl.imageBaseUrl + '/group_05.webp' },
        { image: WtUrl.imageBaseUrl + '/group_06.webp' },
        { image: WtUrl.imageBaseUrl + '/g7.webp' },
        { image: WtUrl.imageBaseUrl + '/g8.webp' },
        { image: WtUrl.imageBaseUrl + '/g10.webp' },
        { image: WtUrl.imageBaseUrl + '/g13.webp' },
        { image: WtUrl.imageBaseUrl + '/g15.webp' },
        { image: WtUrl.imageBaseUrl + '/g16.webp' },
        { image: WtUrl.imageBaseUrl + '/g17.webp' },
        { image: WtUrl.imageBaseUrl + '/g18.webp' },
        { image: WtUrl.imageBaseUrl + '/g19.webp' },
        { image: WtUrl.imageBaseUrl + '/g20.webp' },
        { image: WtUrl.imageBaseUrl + '/g9.webp' },
        { image: WtUrl.imageBaseUrl + '/g12.webp' },
        { image: WtUrl.imageBaseUrl + '/g11.webp' },
        { image: WtUrl.imageBaseUrl + '/g14.webp' },
    ]
    const s1 = { fontSize: '32px' }
    return (
        <div>
            <Container>
                <div className='mt-5'>
                    <p style={s1} className='fw-semibold mb-5 text-center him_sizing'>GALLERY</p>
                    {/* <p className='him_sizedepen' style={s2}>WhatsTool Business started in the year of 2018 with the team of 2, later official office started in Haziribagh with the team of 4. Then later we started our new office branch in Bengaluru location. Then later our clients ratio increased along with our team. We started growing big by solving our customers problem in their field of industry with any size. Now we are a team of 12 Members each having their unique dedication towards work. Hard work and Team work has brought us here.</p> */}
                </div>
                <Row className='mt-5 mb-5'>
                    {
                        TeamGallery.map((v, i) => {
                            return (
                                <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} style={{ marginBottom: '10px' }} key={i}>
                                    <LazyLoadImage src={v.image} alt='whatstool business' style={{ width: '300px', height: 'auto', borderRadius: '8px' }} className='ms-2 me-2 our_story_img_hover' key={i} />
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </div>
    )
}
// End of Team Page by Himanshu



// Conversational Engagement
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
})
export const ConversationalEngagement = () => {
    const reqRef = useRef(null)
    return (
        <div className='mt-4'>
            <ConversationalInfo reqRef={reqRef} />
            <div className='mt-5'><Client /></div>
            <ConversationalSection1 />
            <ConversationalSection2 />
            <ConversationalSection3 />
            <ConversationalSection4 />
            <ConversationalSection5 reqRef={reqRef} />
        </div>
    )
}
export const ConversationalInfo = ({ reqRef }) => {
    const s4 = { width: '80%', height: '12mm', outline: 'none', marginTop: '17px', border: '1px solid gray', borderRadius: '5px', color: 'gray' }
    const s6 = { background: WtColor.BaseColor, marginTop: '17px' }
    const s5 = { width: '80%', height: '12mm', outline: 'none', marginTop: '17px', border: '1px solid gray', borderRadius: '5px', padding: '0 15px' }
    const s3 = { width: '80%', height: '24mm', outline: 'none', marginTop: '17px', border: '1px solid gray', borderRadius: '5px', padding: '10px 15px' }
    const s1 = { color: 'gray' }

    const [countryCode, setCountryCode] = useState('+91')
    const handleCountryCode = (code) => {
        setCountryCode(code)
        handleClose()
    }
    const [mobile, setMobile] = useState('')
    const handleMobile = (val) => {
        let checkedVal = val?.replace(/[^0-9]/ig, '')
        setMobile(checkedVal)
    }

    const [countryCodeLs, setCountryCodeLs] = useState(undefined)
    const getCountryCode = async () => {
        const countryCodeResponse = await fetch('https://raw.githubusercontent.com/love-building-app/letsserve/master/prod/home/CountryCodes.json')
        setCountryCodeLs(await countryCodeResponse.json())
    }
    useEffect(() => { getCountryCode() }, [])

    const [openDialog, setOpenDialog] = useState(false);
    const openCountrySelectionDialogBox = () => {
        setOpenDialog(true)
    }
    const handleClose = () => setOpenDialog(false)

    const [searchLs, setSearchLs] = useState([])
    useEffect(() => { setSearchLs(countryCodeLs) }, [countryCodeLs])
    const searchItems = (searchValue) => {
        const filteredData = countryCodeLs.filter((item) => { return Object.values(item).join('').toLowerCase().includes(searchValue.toLowerCase()) })
        setSearchLs(filteredData)
    }

    // Snackbar Code
    const [errorMsg, setErrorMsg] = useState("")
    const [errorMsgBg, setErrorMsgBg] = useState(WtColor.RedColor)
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const SnackbarShow = (errorMsg, errorMsgBg) => {
        setErrorMsg(errorMsg)
        setErrorMsgBg(errorMsgBg)
        setOpenSnackbar(true)
    }
    const SnackbarClose = () => setOpenSnackbar(false)
    // End of Snackbar Code


    const [name, setName] = useState('')
    const handleName = (val) => setName(val)
    const [companyName, setCompanyName] = useState('')
    const handleCompanyName = (val) => setCompanyName(val)
    const [emailId, setEmailId] = useState('')
    const handleEmailId = (val) => setEmailId(val)
    const [companySize, setCompanySize] = useState('')
    const handleCompanySize = (val) => setCompanySize(val)
    const [message, setMessage] = useState('')
    const handleMessage = (val) => setMessage(val)

    const [formStatus, setFormStatus] = useState(true)
    const validateForm = () => {
        if (name?.length !== 0 && companyName?.length !== 0 && emailId?.length !== 0 && companySize?.length !== 0 && companyName?.length !== 0 && mobile?.length !== 0) {
            setFormStatus(false)
        } else {
            setFormStatus(true)
        }
    }
    useEffect(() => {
        validateForm()
    }, [name, companyName, emailId, companyName, companySize, mobile])

    const handleFormSubmit = async () => {
        try {
            let data = `https://script.google.com/macros/s/AKfycbwnJYBoGRgQfw0MDd6Hg9N1osaosxmtmPUhiHk-HeIijDbXZJo9nvq6pFWs5UzjuNrB/exec?name=${name}&companyName=${companyName}&mobile=${countryCode}${mobile}&email=${emailId}&companySize=${companySize}&message=${message}`
            const response = await fetch(data)
            if (response) {
                handleName('')
                handleCompanyName('')
                handleEmailId('')
                handleCompanySize('')
                handleMessage('')
                setMobile('')
                SnackbarShow('Request Submitted Successfully', WtColor.BaseColor)
            }
        } catch (error) { }
    }
    return (
        <div ref={reqRef}>
            <Container>
                <Row>
                    <div className="text-center mt-5 mb-5">
                        <h3>Conversational engagement on WhatsApp Business is now made Automate </h3>
                        <p style={{ color: 'gray', fontSize: isMobile ? '18px' : '' }}>Engage customers across sales, marketing and customer support with WhatsApp Business API</p>
                    </div>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                        <div>
                            <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_01.webp'} alt="WTB" className="img-fluid" style={{ padding: isMobile ? '0' : '50px' }} />
                        </div>
                    </Col>

                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                        <div>
                            <input value={name} onChange={(e) => handleName(e.target.value)} style={s5} type='text' placeholder="Name" />
                            <input value={companyName} onChange={(e) => handleCompanyName(e.target.value)} style={s5} type='text' placeholder="Company Name" />

                            <div style={{ width: '80%', height: '12mm', outline: 'none', marginTop: '17px', border: '1px solid gray', borderRadius: '5px', display: 'flex' }} >
                                <span onClick={() => openCountrySelectionDialogBox()} style={s1} className="ps-3 pe-2 pt-2 hand">{countryCode}&nbsp;|</span>
                                <input style={{ border: 'none', outline: 'none', width: '85%' }} className='hand' value={mobile} onChange={(e) => handleMobile(e.target.value)} type="tel" placeholder="Mobile Number" />
                            </div>

                            <input value={emailId} onChange={(e) => handleEmailId(e.target.value)} style={s5} type='email' placeholder="Work Email Address" />

                            <Form.Select style={s4} value={companySize} onChange={(e) => handleCompanySize(e.target.value)}>
                                <option value=''>Company Size</option>
                                <option value="1 - 10 employees">1 - 10 employees</option>
                                <option value="11 - 50 employees">11 - 50 employees</option>
                                <option value="51 - 200 employees">51 - 200 employees</option>
                                <option value="201 - 500 employees">201-500 employees</option>
                            </Form.Select>

                            <textarea onChange={(e) => handleMessage(e.target.value)} style={s3} type='text' placeholder="Message (Optional)">{message}</textarea>

                            <button onClick={() => handleFormSubmit()} disabled={formStatus ? true : false} className="text-white btn btn-sm ps-4 pe-4 pt-2 pb-2 fw-semibold rounded-3" style={s6}>Request a Callback</button>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Dialog open={openDialog} TransitionComponent={Transition} keepMounted onClose={handleClose}>
                <input onChange={(e) => searchItems(e.target.value)} placeholder="Select Country Code" required type={'search'} className='form-control'></input>
                <DialogContent>
                    {
                        searchLs?.map((v, i) => {
                            return (
                                <p key={i} className='hand' onClick={() => handleCountryCode(v.dial_code)}>{v.name}{v.dial_code}</p>
                            )
                        })
                    }
                </DialogContent>
            </Dialog>

            <ShowSnackbar open={openSnackbar} errorMsg={errorMsg} errorMsgBg={errorMsgBg} close={SnackbarClose} />
        </div>
    )
}
export const ConversationalSection1 = () => {
    return (
        <div>
            <Container>
                <div style={{ marginTop: '140px' }}>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                            <div>
                                <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_02.webp'} alt="Whatstool Business" className="img-fluid" style={{ padding: isMobile ? '0' : '50px' }} />
                            </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                            <div style={{ marginTop: isMobile ? '54px' : '175px' }}>
                                <h4 className="mb-3">Take Orders on WhatsApp</h4>
                                <h6 style={{ color: 'gray' }} className='mb-3'>Allow your customers to view your shop catalog and order through WhatsApp only</h6>
                                <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_03.webp'} alt="WTB" style={{ height: '80px' }} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export const ConversationalSection2 = () => {
    return (
        <div>
            <Container>
                <div style={{ marginTop: '100px' }}>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                            <div style={{ marginTop: isMobile ? '' : '175px' }} >
                                <h4 className="mb-3">Recover Abandoned Carts on WhatsApp</h4>
                                <h6 style={{ color: 'gray' }} className='mb-3'>Many times user will add the products to the cart and forget to order. Send a reminder on whatsApp in which through a single click it takes them to the checkout page.</h6>
                                <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_04.webp'} alt="WTB" style={{ height: '80px' }} />
                            </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                            <div>
                                <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_05.webp'} alt="Whatstool Business" className="img-fluid" style={{ padding: isMobile ? '0' : '50px' }} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export const ConversationalSection3 = () => {
    return (
        <div>
            <Container>
                <div style={{ marginTop: '100px' }}>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                            <div>
                                <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_06.webp'} alt="Whatstool Business" className="img-fluid" style={{ padding: isMobile ? '0' : '50px' }} />
                            </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} >
                            <div style={{ marginTop: isMobile ? '54px' : '175px' }}>
                                <h4 className="mb-3">Sent Personalised Offer and Notification</h4>
                                <h6 style={{ color: 'gray' }} className='mb-3'>Send promotions, offers, and back-in-stock alerts. Set up campaigns, send re-buy reminders. Send booking confirmations, subscription reminders, delivery updates and more</h6>
                                <LazyLoadImage src={WtUrl.imageBaseUrl + '/con_07.webp'} alt="WTB" style={{ height: '80px' }} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export const ConversationalSection4 = () => {
    const s1 = { border: '1px solid #21cd5b', borderRadius: '12px', boxShadow: '0 0 4px 2px rgb(0 0 0 / 25%)', minHeight: '375px', maxHeight: '375px', marginBottom: '50px' }

    const BenefitBox = [
        { image: WtUrl.imageBaseUrl + '/con_08.webp', title: 'Up-Sell and Cross-sell products' },
        { image: WtUrl.imageBaseUrl + '/con_09.webp', title: 'Wider Target Reach' },
        { image: WtUrl.imageBaseUrl + '/con_10.webp', title: 'Better Connect with Customer' },
        { image: WtUrl.imageBaseUrl + '/con_11.webp', title: 'Cost Effectiveness' },
        { image: WtUrl.imageBaseUrl + '/con_12.webp', title: 'Personilsed Offers' },
        { image: WtUrl.imageBaseUrl + '/con_13.webp', title: 'Schedule New Compaigns' },
        { image: WtUrl.imageBaseUrl + '/con_14.webp', title: 'Achieve better brand recognition' },
        { image: WtUrl.imageBaseUrl + '/con_15.webp', title: 'Greater Customer Retention' },
        { image: WtUrl.imageBaseUrl + '/con_16.webp', title: 'Increased Sales' },
        { image: WtUrl.imageBaseUrl + '/con_17.webp', title: 'Support customers by responding to queries in real-time' },
        { image: WtUrl.imageBaseUrl + '/con_18.webp', title: 'Effectively and instantly interact with clients' },
        { image: WtUrl.imageBaseUrl + '/con_19.webp', title: 'Send contexual responses automatically' }
    ]
    return (
        <div>
            <Container>
                <div style={{ marginTop: '80px' }} className='ps-5 pe-5'>
                    <Row>
                        <div>
                            <h5 className="text-center mb-5 fw-bold">Benefits of WhatsTool Business</h5>
                        </div>
                        {
                            BenefitBox.map((v, i) => {
                                return (
                                    <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} key={i} >
                                        <div className="p-3" style={s1}>
                                            <p className="text-center pt-5 pb-5 pe-3 ps-3">
                                                <LazyLoadImage src={v.image} alt="Wtb" style={{ width: '240px' }} className='img-fluid' />
                                            </p>
                                            <h6 className="text-center mb-5 mt-3 ps-3 pe-3 fw-bold">{v.title}</h6>
                                        </div>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export const ConversationalSection5 = ({ reqRef }) => {
    const PlatformManyIndustries = [
        { image: WtUrl.imageBaseUrl + '/con_20.webp', info: 'E-commerce', title: 'Promote Your products, share catalogs, receive orders online and provide customer support 24/7' },
        { image: WtUrl.imageBaseUrl + '/con_21.webp', info: 'Education Institutions', title: 'From Admit, Onboard, Engage, Give Updates, Solve Queries to Customer Support it helps Educational Institutions improve Admission Rates' },
        { image: WtUrl.imageBaseUrl + '/con_22.webp', info: 'Healthcare & Medicals', title: 'Go the extra mile by providing your patients and customers the ability to reach out to you 24/7 and at every step of their journey' },
        { image: WtUrl.imageBaseUrl + '/con_23.webp', info: 'Food and Restaurants', title: 'Revolutionize your restaurant operations with WhatsApp based ordering, meal and add-ons, payments and real-time delivery updates.' },
        { image: WtUrl.imageBaseUrl + '/con_24.webp', info: 'Tours & Travels', title: 'Assist, Coordinate, Recommend & Plan for your customers journey and make it a perfect trip by providing customer support ' }
    ]
    return (
        <div>
            <Container fluid>
                <Container>
                    <div style={{ marginTop: '65px' }} className='ps-5 pe-5'>
                        <Row>
                            <div>
                                <h5 className="text-center mb-5 fw-bold">One Platform - Many Industries</h5>
                            </div>
                            {
                                PlatformManyIndustries.map((v, i) => {
                                    return (
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                                            <div style={{ marginTop: isMobile ? '0' : '70px' }} key={i}>
                                                <p >
                                                    <LazyLoadImage src={v.image} alt="Break Language" style={{ width: 'auto', height: '150px' }} />
                                                </p>
                                                <div>
                                                    <p style={{ fontSize: '26px' }} className='fw-bold mb-4'>{v.info}</p>
                                                    <p style={{ fontSize: '18px', fontWeight: '400', fontStyle: 'normal' }} >{v.title}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </Container>
            </Container>
            <div className='mt-5' style={{ background: WtColor.BaseColor }}>
                <Container style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', marginTop: '85px' }} className='pt-3 pb-3 mb-5'>
                    <div style={{ flex: 1 }}>
                        <p className='text-white fw-bold' style={{ margin: '10px 0px 0px 0px' }}>You can also insist these features in your Business</p>
                    </div>
                    <div>
                        <button onClick={() => reqRef.current?.scrollIntoView()} className='fw-bold  btn btn-sm' style={{ border: 'none', fontSize: '18px', background: '#fff', color: WtColor.TextMidGrey, padding: '10px 30px' }}>Request a Callback</button>
                    </div>
                </Container>
            </div>
        </div>
    )
}
// End of Conversational Engagement